import { getSingleQuery } from "@/modules/compute/vmQuery.ts";
import { atomFromStandardQueryOptions } from "@/utils/query/queryAtom.ts";
import { atomFamily } from "jotai-family";

export const firewallResourcesAtom = atomFamily((location: string) =>
    atomFromStandardQueryOptions(getSingleQuery, { location }),
);
